import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import routes from '@msteams/Routes/routes'
import { useGetMyAccount } from '@queries/Account'
import { needsOnboarding } from '@helpers/hooks/useNeedsOnboarding'

const OnboardingLayout = () => {
  const navigate = useNavigate()
  const { data: account, isInitialLoading } = useGetMyAccount()

  // Tenant members land here as soon as their tab loads; only someone who can
  // complete workspace setup is sent into the wizard, everyone else gets the
  // app (see needsOnboarding).
  const needsSetup = needsOnboarding(account)

  useEffect(() => {
    if (needsSetup && !isInitialLoading) {
      navigate(routes.private.onboarding)
    }
  }, [needsSetup, isInitialLoading, navigate])

  return <Outlet />
}
export default OnboardingLayout
